"use strict";
(function($, $g, undefined) {
    
    function Vector2D(x, y) {
        if (y !== undefined) {
            this.x = x;
            this.y = y;
        } else {
            this.x = x.x;
            this.y = x.y;
        }
    }
    
    function V(x, y) {
        return new Vector2D(x, y);
    };
    
    Vector2D.prototype = {
        add: function(v) {
            return V(this.x+v.x,this.y+v.y);
        },
        substract: function(v) {
            return V(this.x-v.x,this.y-v.y);
        },
        scale: function(m) {
            return V(this.x*m,this.y*m);
        },
        length: function() {
            return Math.sqrt( this.x * this.x + this.y * this.y );
        },
        angle: function() {//retourne angle en degrées
            return Math.atan2( this.x , this.y)*(180/Math.PI);
        },
        radian: function() {//retourne angle en radian
            return Math.atan2( this.x , this.y);
        }
    };
    
    Vector2D.angle = function(degree) {
        return Vector2D.radian(degree*Math.PI/180);
    };
    Vector2D.radian = function(radian) {
        return V(Math.cos(radian), Math.sin(radian));
    };
    
    $g.Vector2D = Vector2D;
    $g.V = V;
    
})(jQuery, PVPGEngine);
